import { useTranslation } from 'react-i18next'
import { KibModal } from '@chewy/kib-overlays-react'
import { makeStyles } from '@mui/styles'
import { type BasePuiDialogProps, Text } from '@pbt/pbt-ui-components'

import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'

const useStyles = makeStyles(
  (theme) => ({
    content: {
      padding: theme.spacing(3),
      minWidth: 320,
    },
  }),
  { name: 'CancelRxModal' },
)

export interface CancelRxModalProps extends BasePuiDialogProps {}

const CancelRxModal = ({ onClose, open }: CancelRxModalProps) => {
  const classes = useStyles()
  const { t } = useTranslation('Common')

  return (
    <KibModal open={open} title={t('CANCEL_PRESCRIPTION')} onClose={onClose}>
      <div className={classes.content}>
        <Text variant="body2">CancelRxModal</Text>
      </div>
    </KibModal>
  )
}

export default CancelRxModal
